import { MathLerp } from "../../../libs/math-utils";
import VirtualScroll from "virtual-scroll";
import { gsap } from "gsap";
import EmitEvent, {
  BACK_TOP,
  BEFORE_HT_RESIZE,
  HT_RESIZE,
  NEXT_SCREEN,
  OBSERVER_HEIGHT_CHANGED,
  PAGE_AFTER,
  PAGE_BEFORE_LEAVE,
  PAGE_ENTER,
  PAGE_LEAVE,
  SMOOTH_DISABLED,
  SMOOTH_ENABLED,
  SMOOTH_SCROLLING,
  SMOOTH_SCROLLING_STOP,
  WHEEL_SCROLLING,
  WHEEL_SCROLLING_LOCK,
} from "../../../libs/emit-event";
import Services from "../../../libs/services";
import { checkDeviceMobile, isHasTag } from "../../../libs/helper";
import { SmoothScrollItem } from "./smooth-scroll-item";
import services from "../../../libs/services";

export class SmoothScrollWheel {
  constructor() {
    this.DOM = { main: document.querySelector("[data-scroll-container]") };
    this.scrollTopLast = 0;
    this.scrollTopCurrent = 0;
    this.scrollEase = 0.1;
    this.idRequestAnimation = null;
    this.scrollSpeed = checkDeviceMobile() ? 2 : 1;
    this.isStop = true;
    this.isPause = false;
    this.isLockWheel = false;

    this.itemScroller = [];
    this.initScrollerItems();

    this.loop = this.loop.bind(this);
    this.virtualScroll = this.virtualScroll.bind(this);
    this.updateScrollHeight();
    this.bindEvent();
    this.emitEvent();
  }

  initScrollerItems() {
    this.DOM.main
      .querySelectorAll("[data-scroll-section]")
      .forEach((scroller) => {
        this.itemScroller.push(new SmoothScrollItem({ el: scroller }));
      });

    this.DOM.main
      .querySelectorAll("[data-scroll-section] [data-scroll-section]")
      .forEach((el) => {
        this.itemScroller.forEach((item, key) => {
          if (item.DOM.el === el) {
            delete this.itemScroller[key];
          }
        });
      });
  }

  loop() {
    if (this.isStop) return;
    this.scrollTopCurrent = MathLerp(
      this.scrollTopCurrent,
      this.scrollTopLast,
      this.scrollEase
    );
    if (Math.abs(this.scrollTopLast - this.scrollTopCurrent) > 0.1) {
      this.itemScroller.forEach((scroller) => {
        scroller.handleScrolling(this.scrollTopCurrent);
      });

      // this.DOM.main.style.transform = `matrix(1, 0, 0, 1, 0, ${this.scrollTopCurrent})`;
      //this.DOM.main.style.transform = `translate3d(0, ${this.scrollTopCurrent}px, 0)`;
      //document.dispatchEvent(new CustomEvent('scrolling', {detail: {instance: this.scrollTopCurrent}}));
      EmitEvent.emit(SMOOTH_SCROLLING, { instance: this.scrollTopCurrent });
      this.isPause = false;
    } else {
      // this.DOM.main.style.transform = `translate3d(0, ${Math.round(this.scrollTopCurrent)}px, 0)`;
      //this.DOM.main.style.transform = `matrix(1, 0, 0, 1, 0, ${Math.round(this.scrollTopCurrent)})`;
      EmitEvent.emit(SMOOTH_SCROLLING_STOP, {
        instance: this.scrollTopCurrent,
      });
      this.isPause = true;
    }
  }

  moveTop() {
    this.DOM.main.style.transform = `matrix(1, 0, 0, 1, 0, ${this.scrollTopCurrent})`;
  }

  virtualScroll(event) {
    if (this.isStop || this.isLockWheel) return;
    this.scrollTopLast += event.deltaY * this.scrollSpeed;
    this.scrollTopLast = Math.min(
      Math.max(this.scrollTopLast, -this.scrollHeight),
      0
    );
    EmitEvent.emit(WHEEL_SCROLLING, { instance: this.scrollTopLast });
    if (!Services.isResizeObserver) this.updateScrollHeight();
  }

  updateScrollHeight() {
    this.scrollHeight = this.DOM.main.scrollHeight - Services.winSize.height;
    Services.maxScrollHeight = this.scrollHeight;

    if (Services.isPageEnter && this.isPause) {
      this.scrollTopLast = Math.min(
        Math.max(this.scrollTopLast, -this.scrollHeight),
        0
      );
      this.scrollTopCurrent = this.scrollTopLast;
    }

    services.smooth_scrolling_instance = this.scrollTopCurrent;

    this.itemScroller.forEach((scroller) => {
      scroller.getProp();
    });
  }

  scrollToLock({ top }) {
    this.isStop = true;
    this.scrollTopLast -= top;
  }

  goToSection(hasTag) {
    const section = document.querySelector(hasTag);
    if (section) {
      const header = document.querySelector("#header");
      this.scrollTopLast -=
        section.getBoundingClientRect().top -
        header.getBoundingClientRect().height * 1.5;
      this.scrollTopLast = Math.min(
        Math.max(this.scrollTopLast, -this.scrollHeight),
        0
      );
    }
  }

  nextScreen() {
    const fake = { value: this.scrollTopLast };
    gsap.to(fake, {
      value: this.scrollTopLast - Services.winSize.height,
      ease: "power3.inOut",
      duration: 0.8,
      onUpdate: () => {
        this.scrollTopLast = fake.value;
      },
    });
  }

  backTop() {
    const fake = { value: this.scrollTopLast };
    gsap.to(fake, {
      value: 0,
      ease: "power3.inOut",
      duration: 0.8,
      onUpdate: () => {
        this.scrollTopLast = fake.value;
      },
    });
  }

  bindEvent() {
    // window.addEventListener('mousewheel', this.handleWheel.bind(this));
    // window.addEventListener('DOMMouseScroll', this.handleWheel.bind(this));

    this.scroller = new VirtualScroll({
      el: document.body,
      mouseMultiplier: navigator.platform.indexOf("Win") > -1 ? 1 : 0.4,
      firefoxMultiplier: 30,
      touchMultiplier: 4,
      passive: true,
    });

    //fix hasTag link click to section
    document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
      const href = anchor.getAttribute("href");
      if (isHasTag(href) && document.querySelector(href)) {
        anchor.addEventListener("click", (e) => {
          e.preventDefault();
          this.goToSection(anchor.getAttribute("href"));
        });
      }
    });
  }

  emitEvent() {
    EmitEvent.on(HT_RESIZE, () => {
      this.itemScroller.forEach((item) => item.resetStyle());
      this.updateScrollHeight();
      gsap.ticker.add(this.loop);
      this.isStop = false;
      this.isLockWheel = false;

      setTimeout(() => {
        this.scrollTopLast = Math.min(
          Math.max(this.resizeScrolllNote, -this.scrollHeight),
          0
        );
        this.scrollTopCurrent = this.scrollTopLast - 1;
      }, 50);
    });
    EmitEvent.on(WHEEL_SCROLLING_LOCK, this.scrollToLock.bind(this));
    EmitEvent.on(SMOOTH_DISABLED, () => (this.isStop = true));
    EmitEvent.on(SMOOTH_ENABLED, () => (this.isStop = false));
    EmitEvent.on(OBSERVER_HEIGHT_CHANGED, this.updateScrollHeight.bind(this));
    EmitEvent.on(PAGE_BEFORE_LEAVE, () => {
      this.isLockWheel = true;
      this.scroller.off(this.virtualScroll);
    });

    EmitEvent.on(BEFORE_HT_RESIZE, () => {
      this.resizeScrolllNote = this.scrollTopCurrent;
      gsap.ticker.remove(this.loop);
      this.isStop = true;

      this.scrollTopLast = 0;
      this.scrollTopCurrent = 1;

      setTimeout(() => {
        EmitEvent.emit(SMOOTH_SCROLLING, { instance: 0 });
        EmitEvent.emit(WHEEL_SCROLLING, { instance: 0 });

        this.itemScroller.forEach((item) => item.getProp());
      }, 10);
    });

    EmitEvent.on(PAGE_LEAVE, () => {
      this.scrollTopLast = this.scrollTopCurrent = 0;
      this.itemScroller.forEach((item) => item.resetStyle());
      this.itemScroller = [];
      setTimeout(() => {
        gsap.ticker.remove(this.loop);
        this.isStop = true;
      }, 10);
    });

    EmitEvent.on(PAGE_AFTER, this.initScrollerItems.bind(this));
    EmitEvent.on(PAGE_ENTER, () => {
      window.scrollTo(0, 0);
      gsap.ticker.add(this.loop);
      setTimeout(() => {
        this.scroller.on(this.virtualScroll);
        this.isStop = false;
        this.isLockWheel = false;
        this.scrollTopLast = this.scrollTopCurrent = 0;
        if (window.location.hash) this.goToSection(window.location.hash);
        this.itemScroller.forEach((scroller) => {
          scroller.getProp();
        });
      }, 150);
    });

    EmitEvent.on(NEXT_SCREEN, this.nextScreen.bind(this));
    EmitEvent.on(BACK_TOP, this.backTop.bind(this));
  }
}
